
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    OCTBUNKER_ACTION,
    ALL_OCTBUNKER,
    ADD_OCTBUNKER,
    FETCH_OCTBUNKER,
    EDIT_OCTBUNKER,
    DELETE_OCTBUNKER,
    FETCH_OCTBUNKERCHART,
    FETCH_BUNKERSHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Course Bunker Play Actions
 */

    export const allOCTBunkerPlay = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: OCTBUNKER_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getbunkerplay', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTBUNKER, payload: alldata });
            });
        }        
    
    }

    export const studentOCTBunkerPlay = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:OCTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentbunkerplay', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_OCTBUNKER, payload: alldata }); 
            });
        
        }
    }

    export const addOCTBunkerPlay = (data, sepmore) =>{
        var id=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
        
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var sepopt='putt_'+i;            
            var seoptval=data.target[sepopt].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;
            var sepoptadd='putt_1_'+adval; 
            var septraveladd='dhg_1_'+adval;  
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[sepoptadd]=seoptval;
            payload[septraveladd]=setrvalval;            
    
        }

        return (dispatch) => { 
            dispatch({ type:OCTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addbunkerplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    studentOCTBunkerPlay(id, '', '')(dispatch);
                    fetchOnBunkerChart(id, '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_OCTBUNKER});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchOCTBunkerPlay = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:OCTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getbpdetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_OCTBUNKER, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editOCTBunkerPlay = (data, sepmore, oldate) =>{
        var id=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {        
        
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var sepopt='putt_'+i;            
            var seoptval=data.target[sepopt].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;
            var sepoptadd='putt_1_'+adval; 
            var septraveladd='dhg_1_'+adval;  
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[sepoptadd]=seoptval;
            payload[septraveladd]=setrvalval;  
            
    
        }

        return (dispatch) => { 
            dispatch({ type:OCTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editbunkerplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    studentOCTBunkerPlay(id, '', '')(dispatch);
                    fetchOnBunkerChart(id, '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_OCTBUNKER});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteOCTBunkerPlay = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:OCTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletebunkerplay', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    studentOCTBunkerPlay(id, '', '')(dispatch);
                    fetchOnBunkerChart(id, '', '', '')(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_OCTBUNKER});                    
                }                
                
            });
        
        }
    }

    export const fetchOnBunkerChart = (id, start, end, contact) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact            
        }

        return (dispatch) => { 
            dispatch({ type:OCTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onbunkerplayreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                var bunker=resdata.bunker;
                dispatch({ type: FETCH_OCTBUNKERCHART, payload: bunker}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchOnBunkerShotChart = (id, start, end, contact, val) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "section":val            
        }

        return (dispatch) => { 
            dispatch({ type:OCTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onbunkershotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_BUNKERSHOTCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }